<span
  class="op-ian-date-alert--property"
  [textContent]="propertyText"></span>
&ngsp;
<span
  class="op-ian-date-alert--days"
  [textContent]="alertText"></span>
